// TODO: remove comment when final copy is ready
/* eslint-disable string-to-lingui/missing-lingui-transformation */

import {styled} from 'styled-components'

import {Button, Stack, Text, tokens} from '@pleo-io/telescope'
import {ArrowRight} from '@pleo-io/telescope-icons'

import {SkeletonLoader} from '@product-web/telescope-lab/skeleton-loader/skeleton-loader'
import {exhaustiveCheck} from '@product-web/utils'

type CardVariant = 'HELP_CENTRE' | 'DEMO_SALES' | 'DEMO_PLAYGROUND'

type FooterCardProps = {
    variant: CardVariant
    headingLevel: 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
    onClick: () => void
    isLoading?: boolean
}

export const FooterCard = ({
    variant,
    headingLevel,
    onClick,
    isLoading = false,
}: FooterCardProps) => {
    if (isLoading) {
        return (
            <Wrapper>
                <SkeletonLoader width="100%" height="128px">
                    <rect x="0" y="0" rx="3" ry="3" width="140" height="18" />
                    <rect x="0" y="34" rx="3" ry="3" width="100%" height="14" />
                    <rect x="0" y="60" rx="3" ry="3" width="70%" height="14" />
                    <rect x="12" y="88" rx="3" ry="3" width="170" height="40" />
                    <circle cx="20" cy="108" r="20" />
                    <circle cx="180" cy="108" r="20" />
                </SkeletonLoader>
            </Wrapper>
        )
    }

    const {heading, description, ctaText} = getCardContent(variant)

    return (
        <Wrapper>
            <Stack space={4}>
                <Text as={headingLevel} variant="large-accent" weight="semibold">
                    {heading}
                </Text>

                <Text as="p" variant="large-accent">
                    {description}
                </Text>
            </Stack>

            <Button variant="secondary" onClick={onClick} IconRight={ArrowRight}>
                {ctaText}
            </Button>
        </Wrapper>
    )
}

const getCardContent = (variant: CardVariant) => {
    switch (variant) {
        case 'HELP_CENTRE':
            return {
                heading: 'Find answers fast',
                description:
                    'Got a question about setup? Check the how-to guides in our help centre.',
                ctaText: 'Check the help centre',
            }
        case 'DEMO_SALES':
            return {
                heading: 'Talk to sales',
                description:
                    'Our friendly team can help you find the right solution for your business.',
                ctaText: 'Book a demo',
            }
        case 'DEMO_PLAYGROUND':
            return {
                heading: 'Try the demo',
                description: `Play with our demo playground to explore all of Pleo's features.`,
                ctaText: 'Try the Pleo Demo',
            }
        default:
            return exhaustiveCheck(variant)
    }
}

const Wrapper = styled.aside`
    display: flex;
    align-items: start;
    justify-content: space-between;
    flex-direction: column;
    row-gap: ${tokens.spacing8};
    border: ${tokens.borderPrimary};
    border-radius: ${tokens.arc8};
    padding: ${tokens.spacing24};
    background: ${tokens.colorBackgroundInteractive};
`
